import { CircularProgress, Box, Typography } from '@mui/material';

function CircularProgressWithLabel({
	value,
	textColor = 'textSecondary',
	color = '#0B1FCB',
	showBg = false,
	size = 50,
	fontSize = 12,
	display = true,
}) {
	return (
		<Box
			position='relative'
			display='inline-flex'
			sx={{
				display: display ? 'inline-flex' : 'none',
				justifyContent: 'center',
				alignItems: 'center',
			}}>
			{showBg && (
				<CircularProgress
					variant='determinate'
					value={100}
					size={size}
					sx={{ color: '#ffffff', position: 'absolute' }}
				/>
			)}
			<CircularProgress
				variant='determinate'
				value={value}
				size={size}
				sx={{ color: color }}
			/>
			<Box
				top={0}
				left={0}
				bottom={0}
				right={0}
				position='absolute'
				display='flex'
				alignItems='center'
				justifyContent='center'>
				<Typography
					variant='caption'
					component='div'
					color={textColor}
					sx={{
						fontSize: fontSize,
						fontFamily: 'Satoshi, sans-serif',
						fontWeight: 700,
					}}>
					{`${value}%`}
				</Typography>
			</Box>
		</Box>
	);
}

export default CircularProgressWithLabel;
